import { StatsTheme } from '../types'
import { base } from './base'

import bgGradient from '../assets/bg/stats-theme-bg-green.webp'
import upsell from '../assets/upsell/fable-plus-upsell-charts-green.webp'
import { theme } from '@fable/theme'

export const green: StatsTheme = {
  id: 'green',
  name: 'Green',
  colors: {
    base,
    menuDot: base.olive,
    primary: base.olive,
    secondary: base.fern,
    bg: '#C3D4AD',
    bgGradient,
    hero: {
      iconColor: base.olive,
      shareTextColor: base.olive,
    },
    section: {
      bg: theme.colors.uiPearlExtraLight,
      bgSecondary: theme.colors.uiWhite,
      text: theme.colors.uiGraphite,
      textSecondary: theme.colors.uiBlack40,
      textReadingGoal: theme.colors.uiBlack40,
      tabBg: '#0706070D',
      tabBtnBg: theme.colors.uiWhite,
      tabBtnText: {
        idle: theme.colors.uiGraphite,
        active: theme.colors.uiGraphite,
      },
      shareBg: theme.colors.uiWhite70,
      shareText: theme.colors.uiGraphite,
      chart: { ghost: theme.colors.uiWhite50, lines: theme.colors.uiBlack10 },
      legend: { text: theme.colors.uiBlack40 },
    },
    goals: {
      petalEmpty: '#EBE8E2',
    },
    charts: {
      genresPie: ['#4F8111', '#07060766', '#C7C4C0', '#DFDCD7', '#FFFFFF'],
      genreStream: ['#4F8111', '#526C03', '#71C0EF', '#FFC3D2', '#55ACDE'],
      streakMap: {
        default: theme.colors.uiBlack10,
        bestStreak: '#55ACDE',
        daysRead: '#8DC746',
        finished: '#006FEA',
      },
      momStreaks: {
        cellBg: theme.colors.uiWhite70,
        bestStreak: { bg: base.olive, text: theme.colors.uiPearlExtraLight },
        daysRead: { bg: theme.colors.uiBlack10, text: theme.colors.uiBlack40 },
        noReading: {
          current: {
            bg: 'transparent',
            text: theme.colors.uiBlack40,
            border: 'transparent',
          },
          other: {
            bg: 'transparent',
            text: theme.colors.uiBlack40,
            border: theme.colors.uiWhite70,
          },
        },
      },
    },
    blurs: {
      hero: {
        top: 'rgba(141, 199, 70, 0.8)',
        bottom: 'rgba(113, 192, 239, 0.8)',
      },
      section: {
        top: 'rgba(141, 199, 70, 0.5)',
        middle: 'rgba(252, 249, 245, 0.8)',
        bottom: 'rgba(252, 249, 245, 0.8)',
        topAlt: 'rgba(252, 249, 245, 0.8)',
        bg: {
          start: 'rgba(168, 205, 126, 1)',
        },
      },
      sectionAlt: {
        top: 'rgba(85, 172, 222, 0.8)',
        middle: 'rgba(252, 249, 245, 0.8)',
        bottom: 'rgba(0, 111, 234, 0.5)',
        topAlt: 'rgba(252, 249, 245, 0.8)',
        bg: {
          start: 'rgba(123, 189, 225, 1)',
        },
      },
    },
    upsell,
    upsellBtnBg: theme.colors.uiWhite,
    upsellBtnText: theme.colors.uiGraphite,
  },
}
